import clsx from 'clsx';
import * as React from 'react';
import { useRef, useState } from 'react';
import materials from '../../data/materials';
import { useEditor } from '../hooks/useEditor';
import { MaterialKey, Swatch } from '../types';
import ColorSelector from './ColorSelector';
import MaterialItem from './MaterialItem';
import VariationSelector from './VariationSelector';

interface MaterialProps {
    onColorChange?: (swatch: Swatch) => void;
    variations?: string[];
}

export default function Material({
    onColorChange,
    variations,
}: MaterialProps) {
    const {
        editor: { material, swatch },
        selectMaterial,
    } = useEditor();

    function handleMaterialChange(materialKey: MaterialKey) {
        selectMaterial(materialKey);
    }

    const listRef = useRef<HTMLDivElement>(null);
    const [scrollHeight, setScrollHeight] = useState(0);
    const [showList, setShowList] = useState<boolean>(false);

    const toggleList = () => {
        if (listRef.current) {
            setScrollHeight(showList ? 0 : listRef.current.scrollHeight);
        }
        setShowList(!showList);
    };

    return (
        <div className="material">
            <div className="material__controls">
                <span>{materials[material].name}</span>
                <span>{swatch.label}</span>
                {variations && <VariationSelector variations={variations} /> }
                <button
                    className={clsx('button button--small secondary', {
                        isActive: showList,
                    })}
                    onClick={toggleList}
                >
                    select material
                </button>
            </div>
            <div
                ref={listRef}
                style={{
                    maxHeight: scrollHeight,
                }}
                className={clsx('material__list', {
                    isOpen: showList,
                })}
            >
                {Object.entries(materials).map(
                    ([materialKey, materialItem]) => (
                        <MaterialItem
                            key={materialKey}
                            materialKey={materialKey}
                            {...materialItem}
                            onClick={() =>
                                handleMaterialChange(materialKey as MaterialKey)
                            }
                        />
                    )
                )}
            </div>

            <div className="material__selector">
                <ColorSelector
                    swatchData={materials[material].swatches}
                    onChange={onColorChange}
                />
            </div>
        </div>
    );
}
